/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Volver",
      "<h3 class=”header-3”>Estado de accesibilidad</h3> <p>La Ley Europea de Accesibilidad exige que diseñemos nuestros servicios de comercio electrónico (incluidos los métodos de identificación y pago) teniendo en cuenta la accesibilidad, de modo que sean perceptibles, manejables, comprensibles y robustos. Además, nuestro objetivo es diseñar nuestros sitios web y aplicaciones móviles de conformidad con las <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">Pautas de Accesibilidad al Contenido Web 2.1, Nivel AA, del W3C</a>. Para alcanzar estos objetivos, hemos: </p> <ul> <li>Colaborado con consultoras de accesibilidad como Level Access para comprender cómo podemos hacer que nuestros servicios sean más accesibles.</li> <li>Evaluado nuestras experiencias digitales según los estándares de accesibilidad globales.</li> <li>Aprendido de un equipo diverso de especialistas en accesibilidad, incluyendo persona usuarias con discapacidades y necesidades de accesibilidad adicionales.</li> </ul>",
      "<h3 class=”header-3”>Retroalimentación y Contacto</h3> <p>Aunque nuestro objetivo es garantizar la accesibilidad para todas las personas usuarias, pueden existir algunas limitaciones. Agradecemos cualquier comentario que nos ayude a mejorar, por lo que, si encuentras barreras de accesibilidad o necesitas información en un formato alternativo, contáctanos en accessibility@bumble.com.</p>",
      "<h3 class=”header-3”>Próximas mejoras</h3> <p>Nuestro trabajo en materia de accesibilidad es un proceso continuo. Seguiremos:</p> <ul> <li>Supervisando y revisando la accesibilidad en todas las plataformas digitales.</li> <li>Solucionando los problemas conocidos y previniendo obstáculos futuros mediante un diseño que tenga en cuenta la accesibilidad.</li> <li>Ampliando la formación y la sensibilización internas para mejorar las prácticas de diseño inclusivo.</li> </ul>",
      "<h3 class=”header-3”>Última actualización: noviembre de 2025</h3>",
      "<h3 class=”header-3”>Medidas tomadas</h3> <p>Para garantizar la accesibilidad de nuestros servicios, hemos:</p> <ul> <li>Colaborado con Level Access para llevar a cabo evaluaciones exhaustivas de accesibilidad y recibir asesoramiento.</li> <li>Incorporado herramientas de accesibilidad en nuestras plataformas, incluidas tecnologías de apoyo como alternativas al teclado, funciones de voz y navegación sin contacto.</li> <li>Realizado pruebas con personas usuarias con discapacidad para recabar opiniones reales y orientar las mejoras.</li> <li>Integrado consideraciones de accesibilidad en nuestro ciclo de vida de desarrollo de productos y en los procesos de control de calidad.</li> <li>Establecido un programa de accesibilidad digital en toda la organización.</li> <li>Implementado una <a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">plataforma de asistencia para la experiencia de la clientela</a>. Esta plataforma es gratuita y está disponible para personas que tienen dificultades para escribir, realizar gestos, mover el ratón o leer. Incorpora herramientas como sustitutos del ratón y el teclado, reconocimiento de voz, activación por voz, navegación sin manos/sin contacto y mucho más.</li> </ul>",
      "<h3 class=”header-3”>Nuestra política</h3> <p>En Bumble, la equidad es uno de nuestros valores fundamentales. Es mucho más que una simple palabra de moda: nos esforzamos por hacer que las experiencias en Bumble sean accesibles, justas y equitativas.</p> <p>Esta declaración de accesibilidad se ha elaborado para informar a nuestras personas usuarias sobre la accesibilidad de nuestro servicio, incluida su conformidad con las normas legales y técnicas pertinentes. Esta declaración de accesibilidad se aplica a los elementos de nuestros servicios [RS2] cubiertos por la Ley Europea de Accesibilidad, en particular a nuestros servicios de comercio electrónico, que permiten a las personas usuarias acceder a una gama de funciones mejoradas y premium de Bumble. Se puede acceder a estos servicios a través de la app de Bumble.</p>",
      "Acta Europea de Accesibilidad",
      "Descargar en la App Store",
      "Descargar en Google Play",
      "Carrusel",
      "Diapositiva {{number}}",
      "Siguiente diapositiva",
      "Diapositiva anterior",
      "Diapositiva",
      "Diapositiva {{number}} de {{total}}",
      "No vender ni compartir mi información personal",
      "No vender ni compartir mis datos personales",
      "Envía Compliments en Bumble para hacerle saber que te gusta su perfil y captar su interés antes de hacer match. Pruébalo ya",
      "Compliments | Cómo enviar un Compliment | Bumble",
      "Una página personalizada que destaca a las personas más compatibles para ti, actualizada a diario.",
      "Descubre | Encuentra personas compatibles | Bumble",
      "Ten citas a tu ritmo y controla quién ve tu perfil de Bumble con Incógnito. Descubre cómo usar el modo Incógnito en Bumble en nuestra guía",
      "Modo Incógnito | Oculta tu perfil | Bumble",
      "Después de conoceros en un evento IRL de Bumble, mantén la química conversando en la app.",
      "Match al instante | Sigue la conversación en la App | Bumble",
      "¿Necesitas un pequeño descanso o algo de tiempo para ti? Descubre cómo poner en pausa tu cuenta de Bumble con No molestar de Bumble. Para tener citas a tu aire",
      "No molestar | Pausa tu cuenta | Bumble",
      "¿Has visto a alguien que te gusta un montón en Bumble? Usa un SuperSwipe para demostrarle que vas en serio. Toca la estrella de su perfil para empezar, o consulta más detalles aquí",
      "Bumble SuperSwipe | ¿Qué es un SuperSwipe? | Bumble",
      "¿De viaje por trabajo o por placer? Viajes de Bumble te ayudará a conocer gente nueva y divertida en cualquier lugar y a tener citas allá donde vayas. Descubre Viajes aquí ya mismo",
      "Viajes de Bumble | Citas allá donde vayas | Bumble",
      "¿Quieres saber si esa conexión que sientes por mensajes implicará química en persona? Prueba ahora una videollamada o una llamada de voz en Bumble y haz tu test de buenas vibras",
      "Videollamada | Hacer una llamada | Bumble",
      "Bumble Date",
      "Nuestras apps",
      "Conócenos",
      "Empleo",
      "Contáctanos",
      "Inversores",
      "Tienda",
      "Empresa",
      "Descargar la app",
      "Accesibilidad en Bumble",
      "Normas",
      "Gestionar cookies",
      "Ley de Esclavitud Moderna",
      "Notificación de recopilación",
      "Política de Privacidad",
      "Condiciones de uso",
      "Legal",
      "Política de privacidad de la salud del consumidor de Washington",
      "Escanea el código QR para descargar la app de Bumble",
      "Entrar",
      "Rescindir contratos aquí",
      "Descargar ahora",
      "Solo tienes que escanear el código QR para empezar.",
      "Encuentra tu próxima cita",
      "Descarga la app",
      "Página principal de Bumble",
      "Cerrar menú",
      "Abrir menú",
      "Próximamente: Historias de amor de Bumble",
      "Elige tu idioma",
      "Selección de idioma",
      "Pie de página",
      "Accesibilidad en Bumble",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Empleo",
      "Eventos",
      "Google Play es una marca de Google LLC.",
      "Normas",
      "Inversores",
      "Gestionar cookies",
      "Gestionar cookies",
      "Declaración sobre la Modern Slavery Act",
      "Notificación de recopilación",
      "Política de privacidad",
      "Guía de citas por estaciones",
      "Condiciones de uso",
      "La app",
      "Política de privacidad de Washington Consumer Health",
      "Sobre",
      "Embajadores",
      "Haz nuevas amistades y encuentra tu comunidad",
      "Crea contactos profesionales y avanza en tu carrera",
      "Encuentra una relación, algo casual, o lo que sea entre medias",
      "Blog",
      "Descubrir más",
      "Globalízate con la función Viajes",
      "Date",
      "Eventos",
      "Funciones",
      "Compliments",
      "Utiliza Compliments para que sepa por qué te gusta.",
      "Descubre",
      "Una página personalizada que destaca a las personas más compatibles para ti, actualizada a diario.",
      "Incógnito",
      "Utiliza el modo Incógnito para ocultar tu perfil a tu jefa, familiares o a tu ex.",
      "Match al instante",
      "¿Empezasteis a hablar en un evento IRL de Bumble? ¡Que siga en la app!",
      "No molestar",
      "Tómate un descanso con No molestar. Cuando te apetezca volver a las citas, ya sabes dónde estamos.",
      "SuperSwipe",
      "¿Su perfil te ha... cautivado? Házselo saber con un SuperSwipe.",
      "Viajes",
      "Encuentra tu capricho duty-free y haz match en cualquier parte del mundo con la función Viajes.",
      "Videollamada",
      "Utiliza videollamadas y llamadas de audio para ver si os apetece conoceros en persona.",
      "Descarga la app Bumble",
      "BFF",
      "Seguridad",
      "Historias",
      "Ayuda",
      "Tienda",
      "Principal",
      "Lanza algunos Compliments para destacar.",
      "Compliments",
      "Funciones diseñadas para crear un espacio de relaciones reales, respetuosas y significativas.",
      "Oculta tu perfil a tu jefa, familiares o a tus ex.",
      "Incógnito",
      "Pon las citas en pausa con No molestar.",
      "No molestar",
      "¿Has visto a alguien que te gusta? Haz que lo sepa.",
      "SuperSwipe",
      "Explorar Date",
      "Encuentra tu capricho duty-free y haz match allí donde vayas.",
      "Viajes",
      "Acércate al máximo a la vida real sin salir de casa.",
      "Videollamadas",
      "Consigue la experiencia de Bumble directamente desde tu navegador.",
      "Aplicación web",
      "Líderes que nos ayudan a llevar los valores de Bumble a sus comunidades en todo el país.",
      "Líderes de la comunidad",
      "Funciones diseñadas para ayudarte a encontrar a tu gente y conectar por lo que os apasiona.",
      "Organiza una reunión de grupo o descubre los eventos locales que se celebran en tu zona.",
      "Plans",
      "Explorar BFF",
      "Toda la orientación e inspiración que necesitas para ayudarte a encontrar el amor y la amistad.",
      "Consejos e historias para ayudarte a construir las amistades que deseas.",
      "El Centro de la Amistad",
      "Desde Tokio hasta Toronto, descubre el amor que se encuentra en Bumble por todo el mundo.",
      "Historias de amor",
      "Planifica la cita perfecta, sin importar cuándo, dónde o con quién quieras quedar.",
      "Guía de citas por estaciones",
      "Explorar historias",
      "Ir al contenido principal",
      "Logotipo de Bumble",
      "Cerrar menú de navegación",
      "Abrir menú de navegación",
      "Retrato de Whitney Wolfe Herd, fundadora y directora ejecutiva de Bumble",
      "Whitney Wolfe Herd fundó Bumble con un objetivo: crear el espacio más confiable para encontrar el amor, donde las mujeres den el primer paso y las relaciones se basen en el respeto.{{__EOL__}}{{__EOL__}} Como directora ejecutiva, sigue liderando la empresa con la misma convicción: encontrar el amor en Internet debe ser algo intencional, seguro y auténtico. Bumble es mucho más que una página de citas. Se trata de ayudar a las personas a encontrar lo que realmente importa, con cuidado, intención y corazón. Eso significa usar la tecnología y la inteligencia artificial para profundizar la conexión humana, no para reemplazarla. Estamos utilizando todo lo que hemos aprendido: las cosas buenas, las imperfectas y las honestas, para que toda nuestra comunidad siga sintiéndose bienvenida en Bumble.",
      "Whitney Wolfe Herd",
      "Pareja sonriente inclinándose para darse un beso y dándose la mano en el asiento trasero de un coche, con vegetación al fondo.",
      "Creemos que el amor, en todas sus formas, es la base de una vida feliz y saludable.",
      "¡Hola! Somos la empresa del amor.",
      "Pantalla de matches de Bumble con dos perfiles y un entrante para iniciar la conversación.",
      "¿El resultado? Una plataforma centrada en las personas, diseñada para crear conexiones amables y sanas.",
      "En {{date}}, reescribimos las normas del mundo de las citas.",
      "Nuestra misión es acercar a las personas al amor.",
      "Nuestra misión",
      "Cambiamos las normas del mundo de las citas y ofrecimos a las mujeres la oportunidad de dar el primer paso.",
      "Nace Bumble",
      "{{bff}} se lanzó para ayudar a las personas a encontrar a su gente. Porque la amistad también es amor.",
      "Mucho más que citas",
      "Serena Williams nos ayudó a llevar a las mujeres que dan los primeros pasos a la Super Bowl.",
      "Debut en la Super Bowl",
      "Lanzamos nuevas funciones para navegar por las citas durante la pandemia del Covid.",
      "Las citas se volvieron virtuales",
      "Salimos a bolsa, con la mujer más joven en hacerlo nunca como líder.",
      "Hicimos historia",
      "Además de nuestra tecnología contra el ciberflashing, hemos ampliado nuestras políticas para proteger a las mujeres.",
      "Mayor seguridad",
      "Dimos al deporte femenino la relevancia que se merece.",
      "WNBA x Bumble",
      "Ahora estamos construyendo un futuro en el que el amor sea posible para todo el mundo.",
      "Liderando con amor",
      "Empezamos con una decisión audaz. Hoy en día, estamos construyendo el lugar más fiable y eficaz para encontrar el amor.",
      "Desplaza para explorar",
      "Desplazar a la izquierda",
      "Desplazar a la derecha",
      "Nuestra historia",
      "Ver nuestras vacantes",
      "Ayúdanos a crear el lugar más confiable para encontrar el amor.",
      "Trabaja aquí",
      "Pantallas de la app BFF que resaltan la vista del perfil de la usuaria y las insignias de interés para hacer amistades",
      "Tanto si te has mudado a una nueva ciudad como si simplemente quieres ampliar tu círculo de amistades, {{bff}} te facilita conocer a personas afines que encajen contigo.",
      "Encontrar a tu gente",
      "Collage de perfiles de Bumble que muestran a personas diversas con insignias de DNI verificado, incluida una mujer que se está haciendo un selfie delante de un espejo.",
      "Tanto si te estrenas en el mundo de las citas como si tienes ganas de volver a intentarlo, Bumble Date está diseñado para acercarte al amor de forma segura y significativa.",
      "Conocer gente",
      "Mujer sonriente en un parque con un monopatín en la mano",
      "Al aire libre",
      "Hombre corriendo y sonriendo en un parque urbano",
      "Correr",
      "Mujer sosteniendo un pequeño perro peludo al aire libre",
      "Tengo un perro",
      "Descargar Bumble",
      "Queremos que nuestra comunidad encuentre relaciones significativas y auténticas que despierten confianza e ilusión.",
      "Existimos para acercar a las personas al amor.",
      "Mujer con una larga coleta morena, camiseta negra y gafas de sol en la cabeza, sonriendo con el mar tras ella.",
      "Hombre con barba y camisa estampada sosteniendo una cámara, de pie al aire libre con árboles y edificios al fondo.",
      "Mujer con chaqueta fucsia con franja arcoíris y auriculares plateados, collar de estrellas verdes, mirando la cámara.",
      "Pareja sonriente abrazándose en un retrato en blanco y negro",
      {
            "__cfg": {
                  "lexem_id": 31188744,
                  "flex_vars_types": {
                        "num": "Num"
                  },
                  "values": {
                        "Default": "{{name1}} y {{name2}}, {{num}} años de relación",
                        "num=singular": "{{name1}} y {{name2}}, {{num}} año de relación"
                  }
            }
      },
      "Descubrir más",
      "Leer más historias",
      "\"{{__EOL__}}Ya somos dos personas positivas y optimistas por naturaleza, pero cuando nos juntamos, sentimos que no hay nada que no podamos lograr.",
      "Dos personas riéndose en una pista de tenis; una de ellas se tapa los ojos con pelotas de tenis",
      "Quedar en persona",
      "Los eventos IRL de Bumble te permiten dejar de escribir y empezar a hablar. Ven por tu cuenta o trae a tu colega, y vete con una nueva conexión.",
      "Vamos a hablar en persona",
      "Personas disfrutando sus conexiones en Bumble a través de fotos, chats de video y consejos expertos.",
      "Inscribirme",
      "Ayuda a dar forma al futuro de Bumble uniéndote a nuestro Círculo de Miembros. Esta selecta comunidad de personas usuarias comparte ideas directamente con nuestro equipo a través de chats, debates y pruebas de productos.{{__EOL__}}{{__EOL__}}Quienes participen tendrán acceso anticipado a nuevas funciones, podrán echar un vistazo a las próximas campañas y tendrán la oportunidad de ayudar a que Bumble sea aún mejor para todo el mundo.",
      "Comparte tus ideas",
      "¿Quieres conocer a alguien? ¡Haz una videollamada en Bumble!",
      "Simplemente toca el icono de vídeo en tu chat para iniciar una videollamada, todo ello sin compartir ninguna información de contacto personal.",
      "¿Cómo funciona la videollamada en Bumble?",
      "No. Todas las llamadas y chats de Bumble garantizan la seguridad y protección de tus datos personales. No tendrá tu número ni ningún otro dato de contacto hasta que tú se lo digas.",
      "¿Mi match puede ver mi número de teléfono?",
      "¡Claro que sí! Si todavía no te atreves a un cara a cara, las llamadas de voz te permiten conectar a través de audio. Solo tienes que seleccionar el icono de llamada.",
      "¿Puedo probar solo con una llamada de audio?",
      "Nos encanta una buena notificación de *mensaje recibido*. Pero sabemos que es difícil prever si tus charlas van a ser igual de buenas en persona. Ahí es donde entran en juego las videollamadas y las llamadas de audio.",
      "Videollamada en Bumble",
      "<a href={{video_chat_url}}>Las videollamadas y llamadas de audio</a> te pueden ayudar a que os conozcáis mejor y decidir si quieres llevar las cosas más allá de la app. Lo mejor de todo es que cuando realizas una llamada a través de Bumble, no tienes que intercambiar números de teléfono, por lo que tu información personal permanece a salvo hasta que quieras compartirla.",
      "Comprueba vuestra química con una videollamada",
      "Acorta la distancia entre las citas online y en persona, y decide si ha llegado el momento de dar el salto y quedar.",
      "Conoceos mejor (y más rápido). Hablar mientras os veis las caras o charlar por teléfono puede revelar mucho sobre alguien.",
      "Tú mandas. Mantendremos tus datos de contacto en privado, para que puedas elegir cuándo compartirlos.",
      "Ver si te apetece conoceros en persona",
      "Hacer un vibe check rápido",
      "Conectar sin facilitar información personal",
      "Motivos para utilizar las llamadas y videollamadas",
      "¿Todo listo para empezar una conversación? Puedes elegir entre iniciar una llamada de audio o una videollamada directamente desde el chat de la app de Bumble. Para realizar una videollamada, toca el icono gris de la cámara de vídeo en la esquina superior derecha. También verás tres puntos junto al icono, pulsa sobre ellos y verás la opción de realizar también una llamada de audio.",
      "Hacer una videollamada",
      "¿Te apetece probar Compliments?",
      "Cuando envíes un Compliment, la persona que lo reciba lo verá al aparecer tú en su cola.",
      "¿Qué ocurre cuando alguien recibe un Compliment en Bumble?",
      "Si su Compliment te ha llamado la atención, adelante, haz match. Verás el Compliment en tu chat y se aplicarán las reglas habituales para <a href={{make_the_first_move_url}}>Dar el primer paso</a>.",
      "¿Cómo respondo a un Compliment?",
      "Puedes enviar {{num}} [[Compliments:num]] de forma gratuita. Cuando te quedes sin ellos, podrás comprar más en la app de Bumble en paquetes de hasta 30. Uno de ellos se utilizará para enviar ese Compliment (guarda el resto para cuando veas otro perfil que te guste). No te preocupes, ¡no caducan!",
      "¿Cuántos Compliments puedo enviar?",
      "Una palabra simpática (o dos) puede llevarte muy lejos. Si quieres enviar un Compliment pero te paralizas ante el teclado, inspírate con estos:",
      "Ver más ejemplos",
      "“Cualquiera que aprecie a [nombre de artista], tiene buen gusto.”",
      "\"¡Tu sonrisa es contagiosa!\"",
      "“Me parto con tu bío. Muy buena.”",
      "Envía mejores compliments en Bumble",
      "¿Quieres alegrarle el día? Entonces es hora de utilizar Compliments.",
      "Compliments en Bumble",
      "Utiliza Compliments en Bumble para hacer saber a tu posible match que te gusta su perfil (y tal vez sacarle los colores). Compliments forma parte de tu suscripción {{service_level_lexeme_name}}. También es una forma de enviar y recibir mensajes incluso antes de que hayáis hecho match.",
      "Mecanismo de la función Compliments",
      "Cuando recibas un Compliment, aparecerá en el perfil de la persona que lo envía. También te llegará una notificación diciéndote que a alguien le gusta parte de tu perfil.",
      "Mira tus compliments",
      "Puedes enviar un Compliment pulsando el icono del corazón amarillo que aparece en la parte inferior del perfil de alguien. El lugar donde pulses es importante, porque estarás reaccionando a esa foto o parte específica de su perfil. Al hacer clic, se abrirá un cuadro de texto para que escribas tu mensaje (¡Puede tener hasta 150 caracteres!).",
      "Enviar un Compliment",
      "DESCARGA Bumble PARA PROBAR DESCUBRE YA",
      "Todos los días a partir de las 9 de la mañana, verás gente nueva para ti en Descubre. Puedes conectar con esas personas por las cosas que tenéis en común.",
      "¿Cuándo se actualiza Descubre?",
      "Tu página Descubre clasifica a tus matches potenciales en 3 categorías principales: intereses similares, mismos objetivos de citas y comunidades en común. También se muestran recomendaciones de perfiles basadas en matches previos.",
      "¿Cómo se elabora mi página Descubre?",
      "Una página personalizada que destaca a las personas más compatibles contigo, actualizada cada día",
      "ENCUENTRA GENTE QUE VIBRE CON TU ENERGÍA CON {{qr_code}} DESCUBRE",
      "Descubre te muestra una selección de personas que creemos que te gustarán, basada en vuestros objetivos de citas, comunidades e intereses similares.",
      "Probar Descubre",
      "¿BUSCAS UNA NUEVA FORMA DE SABER LO QUE TENÉIS EN COMÚN?",
      "La página Descubre se actualiza cada día para mostrarte aún más personas con las que puedes ser compatible, para que dediques menos tiempo a buscar un match y más a profundizar con personas con las que sabes que vas a vibrar.",
      "RECOMENDACIONES ACTUALIZADAS A DIARIO",
      "Las recomendaciones de Descubre se basan en tu perfil y en las personas con las que has hecho match previamente, de modo que verás a gente a la que le gusta lo que a ti te gusta y que quiere lo que tú quieres, ya sean rollitos de langosta veganos o una relación estable.",
      "PERSONALIZADO{{__EOL__}}A TU MEDIDA",
      "Descargar Bumble",
      "Preguntas frecuentes",
      "¿Te apetece explorar Bumble sin que te vean?",
      "Cuando actives Incógnito, no aparecerás ante otros miembros de Bumble a menos que te guste su perfil.",
      "¿Cómo funciona el modo Incógnito?",
      "Sin Incógnito, tu perfil es visible para otras personas en Bumble cuando encajas con sus preferencias, como la edad y la ubicación. Si activas el modo Incógnito, solo te verán las personas a las que hayas dado like.",
      "¿Quién puede verme en el modo Incógnito de Bumble?",
      "Usar el modo Incógnito no es lo mismo que <a href={{blocking_on_bumble_url}}>bloquear a alguien en Bumble</a>. Con esta función, si te gusta alguien (o si les has enviado un mensaje en el pasado), podrá ver tu perfil.",
      "¿Es Incógnito como bloquear a alguien?",
      "Controla quién ve tu perfil con Incógnito de Bumble.",
      "Incógnito en Bumble",
      "Si quieres dar un paso atrás en tus citas o navegar por Bumble sin que otras personas disponibles vean tu perfil, puedes activar la función Incógnito. Al hacerlo, ocultarás tu perfil a todo el mundo, a menos que antes le hubieras dado like. Esto te permite controlar lo que compartes y quién lo ve.",
      "Oculta tu perfil con Incógnito",
      "Tú decides quién puede ver tus fotos y tu información personal.",
      "¿Quieres incluir algo personal en tu perfil? Puedes compartir discretamente lo que quieras con tus matches actuales.",
      "Navega libremente sin preocuparte de encontrarte con tu ex, tu colega de trabajo o cualquier otra persona que no esté en tu radar de citas.",
      "Tienes el control total",
      "Eliges lo que compartes",
      "Evitas encuentros incómodos",
      "Motivos para amar el modo Incógnito",
      "El modo Incógnito está disponible para las personas usuarias de {{service_level_lexeme_name}} y {{service_level_lexeme_name_two}}. Una vez que te hayas registrado, puedes activarlo yendo a la pestaña de tu perfil, pulsando Ajustes en la esquina superior derecha y cambiando a Incógnito.",
      "Pasar a {{service_level_lexeme_name}}",
      "Usar Incógnito en Bumble",
      "DESCARGA Bumble PARA PROBAR MATCH AL INSTANTE HOY",
      "En la app de Bumble, dirígete al icono del Perfil en la parte inferior de tu pantalla. Desde allí, encontrarás el icono del código QR en la esquina superior derecha de la pantalla. Tócalo para acceder a él.",
      "¿Dónde puedo encontrar mi código QR personal?",
      "¡Qué va! Tendrás que tener conexión a internet, ya sea a través de datos móviles o Wi-Fi, y utilizar el código QR válido para que Match al instante funcione.",
      "¿Puedo capturar mi código QR para compartir?",
      "¡No! Basta con que una persona escanee el código para que hagáis match automáticamente.",
      "¿Ambas personas tienen que escanear el código QR?",
      "Con Match al instante, puedes ver automáticamente lo que tú y tu nuevo match tenéis en común, dándote una idea de vuestra compatibilidad desde el principio.",
      "ENCUENTRA LO QUE TENÉIS EN COMÚN, MÁS RÁPIDO",
      "¿Empezasteis a hablar en un evento IRL de Bumble? ¡Que siga en la app!",
      "CONVIERTE TU ENCUENTRO CASUAL EN UN {{qr_code}} MATCH AL INSTANTE",
      "Match al instante hace que tus encuentros de película pasen al nivel de \"sigamos hablando\" sin necesidad de intercambiar números ni perfiles sociales. Simplemente pídele que escanee tu código QR para hacer match en Bumble.",
      "Probar Match al instante",
      "¿CONOCISTE A ALGUIEN EN UN EVENTO IRL DE Bumble?",
      "En lugar de intercambiar perfiles sociales o números de teléfono, Match al instante te permite comprobar primero vuestra conexión en la app. Así podréis conoceros mejor a vuestro aire, gracias a la variedad de funciones de seguridad de Bumble.",
      "UNA FORMA MÁS SEGURA DE CONECTAR",
      "Después de sentir la química en un evento IRL de Bumble, aprovecha para seguir hablando en la app y conectar a través de vuestros intereses en común, ya sea el amor por el pour-over perfecto o la propagación de suculentas poco comunes.",
      "QUE LA CONVERSACIÓN NO PARE",
      "¿Quieres tomarte un descanso? Prueba No molestar",
      "Sí, puedes visitar tus ajustes o tu cola y desactivar No molestar cuando quieras.",
      "¿Puedo desactivar No molestar antes de tiempo?",
      "Ve a ajustes, pulsa No molestar y elige el tiempo que quieras estar ausente. Vuelve cuando sientas que quieres hacerlo.",
      "¿Cómo uso No molestar en mi perfil?",
      "No, mientras utilices No molestar, toda la actividad de deslizar y chatear estará en pausa. Cuando vayas a ver a gente nueva, te aparecerá un mensaje indicándote cuánto tiempo del modo No molestar te queda, con la opción de desactivarlo.",
      "¿Puedo explorar perfiles y chatear en el modo No molestar?",
      "Las personas a las que ya les has enviado un mensaje verán tu estado como \"Ausente\" (si decides configurarlo). De lo contrario, verán tus mensajes anteriores en su Bandeja de entrada como de costumbre.",
      "¿Qué verán los matches actuales cuando tenga activado No molestar?",
      "Tienes control total sobre tu actividad en Bumble, y puedes alejarte de la plataforma cuando quieras.",
      "Puedes mantener al día las conexiones existentes mediante tu actualización de estado, para que no parezca que estás haciendo <a href={{ghosted_article_url}}>ghosting</a>. Además, todo está automatizado, por lo que no tienes que enviar ningún mensaje.",
      "Tómate un descanso de la búsqueda activa de citas sin perder tus conexiones o tus chats.",
      "Puedes tener citas (o desconectar) a tu manera",
      "Mantiene actualizadas tus conexiones",
      "Pausa tu actividad, pero no tus conexiones",
      "Razones para amar No molestar",
      "Abre la app de Bumble, visita la pestaña de tu perfil y pulsa el icono del engranaje en la esquina superior derecha. En tus Ajustes, toca en No molestar y elige cuánto tiempo te ausentarás. Puedes ocultar tu perfil durante 24 horas, 72 horas, una semana o indefinidamente.{{__EOL__}}{{__EOL__}}Recuerda que los matches sin chats activos caducarán mientras estés en el modo No molestar. Si decides establecer un estado, las personas con las que estés chateando en ese momento podrán ver que estás ausente.",
      "Mecanismo de No molestar en Bumble",
      "Cuando la vida se te hace bola, No molestar te ayuda. Pausa tu cuenta de Bumble y ten citas a tu aire.",
      "No molestar en Bumble",
      "No molestar es una forma fácil de pausar tu cuenta cuando deseas hacer un descanso del dating. Puedes seguir chateando con tus contactos actuales, pero oculta tu perfil a nuevas personas hasta que te apetezca salir de nuevo. Al activar el modo No molestar, no perderás tu información de perfil ni eliminarás las conexiones existentes.",
      "Pon tu perfil de Bumble en No molestar",
      "Mientras estás en modo No molestar, puedes elegir notificar a las conexiones existentes que estás descansando con una actualización de estado. Elige entre \"Estoy de viaje\", \"Tengo mucho trabajo\", \"Estoy de detox digital\" o \"Me estoy tomando un tiempo\". Sea cual sea tu energía, estamos aquí para ti.",
      "Añadir estado \"Ausente\"",
      "Activar No molestar pausa tu cuenta de Bumble (o {{page_partner_name_bff}}). Tus matches no sabrán que estás en modo No molestar a menos que se lo digas. Si decides salir del modo No molestar antes del tiempo que elegiste inicialmente, vuelve a Ajustes y toca \"No molestar\". Así de fácil.",
      "Pausa tus chats",
      "Prueba SuperSwipe en Bumble",
      "¡Tantos como quieras! Los usuarios de {{service_level_lexeme_name}} obtienen {{num}} [[superswipe:num]] por semana, pero puedes recargar tu saldo en cualquier momento. Los miembros gratuitos pueden comprar paquetes de SuperSwipes.",
      "¿Cuántos SuperSwipes puedo enviar en Bumble?",
      "Después de que alguien use un SuperSwipe en tu perfil, recibirás una notificación de inmediato. También verás una etiqueta encima del nombre de esa persona en su perfil, indicándote que le gustas.",
      "¿Cómo sé si alguien me envía un SuperSwipe?",
      "¿Sientes algo especial por alguien? Hay una forma genial de romper el hielo. Solo tienes que enviar un SuperSwipe para hacerle saber que te gusta y empezar conversaciones inolvidables, más rápido.",
      "SuperSwipe en Bumble",
      "Destacar entre la multitud no siempre es fácil, pero SuperSwipe puede ayudarte a causar una gran primera impresión.{{__EOL__}}{{__EOL__}}Cuando utilices SuperSwipe, se enviará una notificación a la persona que te ha gustado. A continuación, pasarás al primer puesto de su lista con una etiqueta en tu perfil. Si tú también le gustas, es hora de empezar a chatear.",
      "¿Qué es un SuperSwipe?",
      "Atreverte a destacar",
      "Iniciar más chats",
      "Crear más conexiones",
      "SuperSwipe puede ayudarte a…",
      {
            "__cfg": {
                  "lexem_id": 31183052,
                  "flex_vars_types": {
                        "num_three": "Num"
                  },
                  "values": {
                        "Default": "Si tienes <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> o Bumble {{service_level_lexeme_name_one}}, obtienes {{num}} [[superswipe:num]] gratis a la semana. Además, todos los miembros pueden comprar paquetes de hasta {{num_two}} [[superswipe:num_two]] desde la pestaña de perfil. Si tienes {{service_level_lexeme_name_three}}, obtendrás {{num_three}} [[superswipe:num_three]] semanales.{{__EOL__}}{{__EOL__}}Utilizar SuperSwipe es muy sencillo: cuando veas a alguien que te gusta, toca el icono de la estrella amarilla en la parte inferior de su perfil.",
                        "num_three=singular": "Si tienes <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> o Bumble {{service_level_lexeme_name_one}}, obtienes {{num}} [[superswipe:num]] gratis a la semana. Además, todos los miembros pueden comprar paquetes de hasta {{num_two}} [[superswipe:num_two]] desde la pestaña de perfil. Si tienes {{service_level_lexeme_name_three}}, obtendrás {{num_three}} [[superswipe:num_three]] semanal.{{__EOL__}}{{__EOL__}}Utilizar SuperSwipe es muy sencillo: cuando veas a alguien que te gusta, toca el icono de la estrella amarilla en la parte inferior de su perfil."
                  }
            }
      },
      "Así se usa SuperSwipe",
      "Planea citas donde vayas con Viajes de Bumble",
      "<a href={{bumble_premium_url}}>los miembros {{service_level_lexeme_name}}</a> pueden usar Viajes. Actívalo y en tu cola verás nuevas caras de la ciudad que elijas.",
      "¿Cómo uso Viajes?",
      "Prácticamente. Tenemos algunas restricciones de seguridad que pueden cambiar con el tiempo, pero la función Viajes está disponible para la mayoría de los destinos.",
      "¿Puedo usar Viajes en cualquier lugar?",
      "Viajes mostrará tu ubicación como el centro de la ciudad elegida, para que las nuevas conexiones de la zona puedan encontrarte. Verán una nota en tu perfil indicando que has activado Viajes, para que sepan que estás de visita o planeas visitarla.",
      "¿Haciendo las maletas para tus vacaciones? ¿Te mudas por trabajo? Activa Viajes de Bumble para llevarte las citas contigo.",
      "Función Viajes en Bumble",
      "Viajes es tu herramienta definitiva para hacer conexiones mientras estás fuera. Establece tu ubicación en cualquier parte del mundo, y tu perfil aparecerá como si estuvieras en la ciudad que elijas. Esto significa que puedes formar parte del mundo de las citas allá donde tus aventuras te lleven.",
      "¿Qué es Viajes?",
      "Nadie conoce un lugar mejor que la gente de la zona. Viajes puede ayudarte a ponerte en contacto con las personas que harán que tu viaje sea aún más especial.",
      "Establece tu ubicación en la ciudad hasta siete días antes de viajar, para que puedas planificar citas y conocer matches con antelación.",
      "Piensa más allá de los viajes a la playa: puede que estés en casa por vacaciones, viajando por trabajo o explorando una nueva ciudad. Encuentra romanticismo allá donde aterrices.",
      "Encontrar los mejores sitios para salir",
      "Vivir una aventura",
      "Crear conexiones duraderas",
      "Razones para amar la función Viajes",
      "Viajes está disponible para miembros <a href={{bumble_premium_url}}>{{service_level_lexeme_name}} y {{service_level_lexeme_name_two}}</a> de Bumble. Pulsa en el engranaje de Ajustes en la parte superior derecha de tu perfil y desplázate hasta que veas la función Viajes. Elige tu nueva ubicación para empezar a conocer gente de esa zona. Tu perfil informará a tus posibles citas de que estás usando Viajes.",
      "¿Cómo funciona Viajes?",
      "Probar ahora",
      "Aquí, querer bien es sexy, ser tal como eres es perfecto, y las mujeres son lo primero. Siempre.",
      "El santuario de Dar el primer paso™",
      "Las relaciones sanas son fundamentales para llevar una vida positiva y productiva. Bumble está diseñada para ayudarte a que te empoderes mientras creas nuevas conexiones, tanto si quieres salir con alguien, hacer nuevas amistades o ampliar tu red de contactos profesionales.",
      "Qué hace a Bumble diferente",
      "Defendemos la integridad, la amabilidad, la igualdad, la confianza y el respeto durante todas las etapas de cualquier relación. No solo acogemos, sino que celebramos todas las orientaciones, ya estés aquí para encontrar el amor o simplemente para divertirte.",
      "Los valores de Bumble",
      "En Bumble, las mujeres marcan el ritmo dando el Primer paso o proponiendo un Opening Move para que sus matches respondan. Así se cambian las viejas dinámicas de poder y se fomenta la igualdad desde el principio.",
      "Cómo funciona Bumble",
      "Conócenos",
      "Descargar ahora",
      "Es mejor en la app.",
      "Funciones diseñadas para que las citas online sean realmente, ya sabes, placenteras",
      "12 de febrero, 2024",
      "Cómo incrementar la intimidad emocional en tu relación de pareja",
      "25 de enero, 2024",
      "Cómo utilizar Bumble cuando nunca antes has usado una app de citas",
      "5 de febrero, 2024",
      "Deception Detector™",
      "Todas las novedades sobre el mundo de las citas",
      "Tómate un descanso con <b>No molestar</b>. Cuando te apetezca volver a las citas, ya sabes dónde estamos.",
      "Haz una pausa",
      "Utiliza <b>videollamadas</b> y <b>chats de audio</b> para una experiencia lo más real posible sin salir de casa.",
      "Díselo fuerte",
      "Ver más",
      "Elige <b>Opening Moves</b> para invitar a tu match a iniciar el chat, así no tendrás que hacerlo tú.",
      "Menos esfuerzo, más citas",
      "Encuentra tu capricho duty-free y haz match en cualquier parte del mundo con <b>Viajes</b>.",
      "Llévanos lejos",
      "¿Su perfil te ha... cautivado? Házselo saber con un <b>SuperSwipe</b>.",
      "Llama su atención",
      "Utiliza <b>Compliments</b> para que sepa por qué te gusta.",
      "Sácale los colores",
      "Utiliza el modo <b>Incógnito</b> para ocultar tu perfil a tu jefa, familiares o a tu ex.",
      "Perfil encubierto",
      "Ten las citas que tú quieres",
      "Unos meses después, también conoció allí a una de sus damas de honor",
      "Hannah conoció a su ahora marido en Bumble.",
      "Antes de construir su casita juntos, Carène y You-Liang se conocieron en Bumble, donde las fotos de viajes de Carène llamaron la atención de You-Liang.",
      "Carène y You-Liang",
      "Brian y Kaci compartieron destino en el extranjero, pero se conocieron en Bumble",
      "Brian y Kaci",
      "Si funcionó en su caso, podría funcionarte a ti.",
      "Da el siguiente paso",
      "Ver las novedades",
      "Mereces lo mejor, así que hemos diseñado formas estupendas para que tengas más citas y te estreses menos.",
      "Vuelve al sitio al que perteneces",
      "Sobre Bumble",
      "Somos la única app que mejora las citas dando prioridad a las experiencias de las mujeres. Porque cuando las cosas mejoran para las mujeres, mejoran para todo el mundo.",
      "Make the first move™",
      "Encuentra a alguien con quien valga la pena salir y Da el primer paso. Haz conexiones auténticas, vibra con lo que os apasiona y, lo más importante, diviértete.",
      "Conoce a alguien con Bumble Date",
      "Amplía tu círculo con beneficios laborales. Conecta con profesionales para encontrar tu próximo trabajo, una mentoría o incluso tu nueva profesión.",
      "Avanza en tu carrera con Bumble Bizz",
      "Conoce a alguien como tú. O diferente. Haz nuevas amistades con las que descubrir cosas nuevas que hacer, en tu ciudad o fuera.",
      "Haz amistades nuevas en Bumble For Friends",
      "Te damos mucho más que citas",
      "Bumble es la app de citas donde las mujeres dan el primer paso. Es la app que ha revolucionado la forma de tener citas, crea relaciones significativas y networking. Descárgala ahora.",
      "Bumble en {{social_network}}",
      "Saber más",
      "Descarga Bumble desde la App Store o Google Play e inicia sesión con la misma cuenta que utilizaste en la web de Bumble.{{__EOL__}}{{__EOL__}}Escanea el código QR que aparece a continuación con tu teléfono o tableta para empezar.{{__EOL__}}{{__EOL__}}Tus matches y conversaciones te esperan en la app. 💛",
      "Descarga la app",
      "Para poder seguir ofreciéndote la mejor experiencia y funciones de seguridad, Bumble ya solo está disponible como app.",
      "Ahora Bumble es solo una app.",
      "No pierdas ni una conexión",
      "Llamar sin compartir tu número",
      "Confía en que tus matches son reales.",
      "Activa las notificaciones en tiempo real para no perderte ni un mensaje.",
      "Usa nuestras llamadas de voz y de vídeo dentro de la app y pasa del match a los planes en persona de forma segura.",
      "Habla tranquilamente con miembros verificados gracias a la verificación por foto y DNI integrada en la app.",
      "¿Por qué pasar a la app de Bumble?",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "Lo sentimos, pero no hemos podido encontrar la página que estabas buscando.",
      "Contáctanos",
      "Vaya, se ha producido un error",
      "(se abre en otra ventana)",
      "Preguntas",
      "Política de cookies",
      "Premium",
      "Bumble - El Blog",
      "Empleo",
      "Chat",
      "Ciudades",
      "Gestionar cookies",
      "Copyright © 2006 - presente. Bumble. Todos los derechos reservados.",
      "Informe sobre la confianza en las citas",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc.{{__EOL__}}Google Play es una marca de Google LLC.",
      "Descargar",
      "Facebook",
      "Síguenos",
      "Centro de ayuda",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Bumble forma parte de Bumble Inc.",
      "Política de Privacidad",
      "Safety Centre",
      "Mapa web",
      "Declaración de Modern Slavery Act",
      "Condiciones de uso",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "reacciones"
            ],
            "singular": [
                  "reacción"
            ]
      },
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "superswipe": {
            "plural": [
                  "SuperSwipes"
            ],
            "singular": [
                  "SuperSwipe"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
